<template>
	<div>
		<ul class="settings-subnav">
			<li v-if="authUser.permissions.includes('CAMPAIGN_ACCESS')">
				<button type="button" :class="{ active: sub === 'lob' }" @click="sub = 'lob'">
					<i class="fas fa-mail-bulk me-1"></i> LOB
				</button>
			</li>
			<li v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<button type="button" :class="{ active: sub === 'freshbooks' }" @click="sub = 'freshbooks'">
					<i class="fas fa-file-invoice-dollar me-1"></i> Freshbooks
				</button>
			</li>
			<li v-if="authUser.permissions.includes('SETTINGS_GENERAL_ACCESS')">
				<button type="button" :class="{ active: sub === 'salesforce' }" @click="sub = 'salesforce'">
					<i class="fas fa-cloud me-1"></i> Salesforce
				</button>
			</li>
		</ul>

		<LOBSettings v-if="sub === 'lob'" />
		<FreshbooksSettings v-if="sub === 'freshbooks'" />
		<SalesforceSettings v-if="sub === 'salesforce'" />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import LOBSettings from './LOBSettings.vue'
import FreshbooksSettings from './FreshbooksSettings.vue'
import SalesforceSettings from './SalesforceSettings.vue'

export default {
	name: 'IntegrationsSettings',
	components: { LOBSettings, FreshbooksSettings, SalesforceSettings },
	data() {
		return {
			sub: '',
		}
	},
	computed: {
		...mapState(['authUser']),
	},
	created() {
		// Default to the first integration the user can actually see.
		this.sub = this.authUser.permissions.includes('CAMPAIGN_ACCESS') ? 'lob' : 'freshbooks'
	},
}
</script>
